var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticStyle:{"padding":"30px"}},[_c('el-alert',{attrs:{"closable":false,"title":"menu 1-2-2","type":"warning"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }